import YoutubePlayer from './components/youtube-player'

let youtube_players = document.querySelectorAll('[data-ytplayer]')

youtube_players.forEach(player_item => {
  let player = new YoutubePlayer(player_item, (element, videoId) => {
    new YT.Player(element, {
      videoId: player_item.dataset.id,
      host: 'https://www.youtube-nocookie.com',
      playerVars: {
        autoplay: 1,
        rel: 0,
        showinfo: 0,
        wmode: 'transparent',
        autohide: 1
      }
    })
  }, {
    classPlayer: ['yt-player__inner', 'absolute', 'top-0']
  })
})

// menu mobile
const btn = document.querySelector('.mobile-menu-button')
const menu = document.querySelector('.mobile-menu')
// add event listeners
btn.addEventListener('click', function () {
  menu.classList.toggle('hidden')
})
